<template>
  <div>
    <h1>老师列表</h1>
    <el-form class="selectlesson">
      <el-form-item label="选择网校">
        <el-select
          clearable
          multiple
          v-model="model.maID"
          @change="getTeacher"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          multiple
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item clearable label="二级分类">
        <el-select
          clearable
          multiple
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            clearable
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getTeacher"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item>
        <el-input
          style="margin-bottom: 15px"
          placeholder="请输入姓名"
          v-model="model.teName"
          @keydown.enter.native="srarchTeacher"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="srarchTeacher"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <template v-if="teacher">
      <el-table border :data="teacher" style="width: 100%">
        <el-table-column
          prop="createAt"
          label="创建日期"
          :formatter="formatDate"
          width="140"
        >
        </el-table-column>
        <el-table-column label="讲师头像" width="100">
          <template slot-scope="scope">
            <el-avatar
              style="width: 80px; height: 80px"
              :src="scope.row.teImg"
            ></el-avatar> </template
        ></el-table-column>
        <el-table-column
          prop="teID"
          label="讲师ID"
          width="100"
        ></el-table-column>
        <el-table-column prop="teName" label="讲师姓名" width="100">
        </el-table-column>
        <el-table-column prop="teDesc" label="讲师介绍"> </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="$router.push(`/teacher/edit/${scope.row.id}`)"
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              >编辑</el-button
            >
            <el-button
              style="margin: 10px 3px 3px 0px"
              @click="dteacher(scope.row.teID)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-skeleton :loading="loading" :rows="10" animated />
    <div class="th-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="thpre"
        @next-click="thnext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="tLength"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
//import moment from 'moment'
import { timerfilter } from "../util/timerfilter";

export default {
  data() {
    return {
      loading: true,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      tLength: 0,
      model: {},
      imageUrl: "",
      teacher: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    //获取三级分类，分页、跳转等功能
    async getTeacher() {
      if (this.model.teName) {
        const result = await this.$http.get("/category/srarchTeacher", {
          params: {
            page: this.currentPage,
            size: this.pageSize,
            teName: this.model.teName,
          },
        });
        this.teacher = result.data.result.map((item) => {
          return {
            teDesc: item.teDesc,
            teID: item.teID,
            teImg: "/" + item.teImg,
            teName: item.teName,
            id: item._id,
          };
        });
        this.tLength = result.data.resultLength;
        //console.log(result);
      } else {
        try {
          const teacher = await this.$http.get("/category/geteacher", {
            params: {
              page: this.currentPage,
              size: this.pageSize,
              maID: this.model.maID,
              chID: this.model.chID,
              coID: this.model.coID,
              clID: this.model.clID,
            },
          });
          //console.log(teacher.data[0].result);
          this.teacher = teacher.data[0].result.map((item) => {
            return {
              teDesc: item.teDesc,
              teID: item.teID,
              teImg: "/" + item.teImg,
              teName: item.teName,
              id: item._id,
            };
          });
          this.tLength = teacher.data[0].resultLength[0].totalCount;
          this.loading = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async srarchTeacher(event) {
      if (!event.ctrlkey) {
        event.preventDefault();
        this.getTeacher();
      }
    },
    async dteacher(teID) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.get(
            "/category/dteacher?teID=" + `${teID}`
          );
          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getTeacher();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getlesson(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        this.getTeacher(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        this.getTeacher(item);
      } catch (error) {
        console.log(error);
      }
    },
    async thpre() {
      try {
        this.currentPage--;
      } catch (error) {
        console.log(error);
      }
    },
    async thnext() {
      try {
        this.currentPage++;
      } catch (error) {
        console.log(error);
      }
    },
    async changeSize(size) {
      try {
        this.pageSize = size;
      } catch (error) {
        console.log(error);
      }
    },
    async currentChange(currentPage) {
      try {
        this.currentPage = currentPage;
        this.getTeacher(this.currentPage);
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); /* moment(date).format('YYYY-MM-DD HH:mm') */
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getTeacher();
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.th-page {
  margin-top: 15px;
  text-align: right;
}
</style>
